import { NavLink } from 'react-router';
import { useI18n } from '../../lib/i18n/runtime';
import { unreadLabel, useUnreadCount } from './notifications.api';

/** Header link to the inbox; the accessible name carries the unread count. */
export function NotificationBell({ workspaceId }: { workspaceId: string }) {
  const { t } = useI18n();
  const unread = useUnreadCount(workspaceId);
  const count = unread.data?.unreadCount;
  return (
    <NavLink
      to={`/w/${workspaceId}/notifications`}
      className="notification-bell"
      aria-label={unreadLabel(count)}
    >
      <span aria-hidden="true">🔔</span>
      <span aria-hidden="true">{t('notifications')}</span>
      {count !== undefined && count > 0 && (
        <span className="notification-bell__count" aria-hidden="true">
          {count > 99 ? '99+' : String(count)}
        </span>
      )}
    </NavLink>
  );
}
